export default __webpack_public_path__ + "static/media/promocionAlarma1.a58553ea.png";